import { Injectable } from '@angular/core';
import { LocalRecipeBoxData } from './local-recipe-box-data';
import { AppSettings } from '../../../config/app-settings';
import { ElasticSearchService, ElasticResult } from '../../../providers/elastic-search';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
import { FireBaseObjectNames } from '../../../core/codes';
import firebase from 'firebase';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/combineAll';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeAll';
@Injectable()
export class UserRecipeBoxData {
    private elasticSearch: any;
    //private userRecipes = [];
    private userRecipesNode = 'user-recipes';
    constructor(public settings: AppSettings,
        public elasticSearchService: ElasticSearchService,
        public afw: AngularFireDatabaseWrapper,
        public localRecipeBox: LocalRecipeBoxData) {
        if (!this.settings.elasticSearch || !this.settings.elasticSearch.config || !this.settings.elasticSearch.config.host) {
            this.settings.getData().subscribe(sets => {
                this.elasticSearch = this.settings.elasticSearch[this.userRecipesNode];
            });
        }
        else {
            this.elasticSearch = this.settings.elasticSearch[this.userRecipesNode];
        }

    }

    public getUserRecipes(userId?) {
        let strgRef = FireBaseObjectNames.USER_RECIPES + '/' + userId;
        return this.afw.object(strgRef).take(1);
    }
    public get(userId, recipeId) {
        let strgRef = FireBaseObjectNames.USER_RECIPES + '/' + userId + '/' + recipeId;
        return this.afw.object(strgRef).take(1);
    }

    public remove(userId,recipe ) {
        return new Promise((resolve, reject) => {
            let recipeId = recipe.$key !== undefined ? recipe.$key : recipe.$id;
            let strgRef = FireBaseObjectNames.USER_RECIPES + '/' + userId + '/' + recipeId;
            let timestampRef = FireBaseObjectNames.USER_RECIPES + '/' + userId;
            this.afw.object(strgRef).remove().then(()=>{
            this.localRecipeBox.remove(userId,recipe);
            this.updateTimeStampModified(timestampRef);                      
            });
            resolve(true);
        });

    }
    public add( userId, recipe) {
        return new Promise((resolve, reject) => {
            // Get timestamp
            let recipeId = recipe.$key !== undefined ? recipe.$key : recipe.$id;
            
            var userRecipe = {
                title: recipe.title,
                description: recipe.description,
                thumbnail: recipe.thumbnail,
                keyword: recipe.title + " " + recipe.description + " " + recipe.tags + " " + recipe.pansize + " " + recipe.pansize + " " + recipe.cookTime + " min " + recipe.prepareTime + " min ",
                categories: recipe.categories?recipe.categories:{"null":{"categoryName":"null"}},
                pansize: recipe.pansize,
                prepareTime: recipe.prepareTime
                // recipeId: recipe.recipeId
            };
            let strgRef = FireBaseObjectNames.USER_RECIPES + '/' + userId + '/' + recipeId;
            let timestampRef = FireBaseObjectNames.USER_RECIPES + '/' + userId;
            this.afw.object(strgRef).set(userRecipe).then(() => {
                this.localRecipeBox.add(userId,recipeId,userRecipe);
                return this.updateTimeStampModified(timestampRef);
            });
            resolve(true);

        });
    }
    public syncLocalToRemote(userId,localUserRecipes) {
        return new Promise((resolve, reject) => {
            // Get timestamp
            
            let timestampRef = FireBaseObjectNames.USER_RECIPES + '/' + userId;
            _.forEach(localUserRecipes, (localUserRecipe: any, key) => {
                let strgRef = FireBaseObjectNames.USER_RECIPES + '/' + userId + '/' + key;
                this.afw.object(strgRef).set(localUserRecipe);
            });
            this.updateTimeStampModified(timestampRef);
            resolve(true);
        });
    }
    public updateTimeStampModified(ref) {
       let timeStamp = (<any>firebase.database).ServerValue.TIMESTAMP;
        return this.afw.object(ref).update({ timestampModified: timeStamp });
        // .then((result) => {
        //     // console.log(result);
        //     // let storageKey = 'strg:' + ref;
        //     // let unixtime = new Date().getTime();
        //     // console.log(unixtime);
        //     // return this.localRecipeBox.updateTimeStampModified(storageKey, unixtime);
        // });
    }
        
    public searchByCategory(term) {
        // console.log('--------searchRecipesByCategory');
        // var size = parseInt(pageSize);
        // var currentPage = parseInt(pageIndex);
        // var from = size * currentPage;
        // if (from > 0) {
        //     from = from - 1;
        // }

        //create query
        var query: any = {
            index: this.elasticSearch.index,
            type: this.elasticSearch.type,
            size: 5000
        };

        if (term && term != null && term.trim() === '') {
            query.body = {};
            query.body.query = {
                bool: {
                    must: {
                        match_all: {}
                    }
                }
            };
        } else {
            query.body = {};
            query.body.query = {
                bool: {
                    must: {
                        match: {
                            'categories.Id': term
                        }
                    }
                    // },
                    // must_not:{
                    //     match:
                    //     {
                    //         tags: 'Appetizer'
                    //     }
                    // }

                }
            };
        }

        // if (sort) {
        //     query.sort = sort + ':desc';
        // }

        return this.elasticSearchService.Search(query, this.elasticSearch.path, false).map(result=>{
            return result;
        });
    }
    public _searchByUserId(term, full?) {
        // var size = parseInt(pageSize);
        // var currentPage = parseInt(pageIndex);
        // var from = size * currentPage;
        // if (from > 0) {
        //     from = from - 1;
        // }

        //create query
        var query: any = {
            index: this.elasticSearch.index,
            type: this.elasticSearch.type,
            size: 5000
        };

        if (term && term != null && term.trim() === '') {
            query.body = {};
            query.body.query = {
                bool: {
                    must: {
                        match_all: {}
                    }
                }
            };
        } else {
            query.body = {};
            query.body.query = {
                bool: {
                    must: {
                        match: {
                            'userId': term
                        }
                    }

                }
            };
        }

        // if (sort) {
        //     query.sort = sort + ':desc';
        // }

        let elasticObserval = this.elasticSearchService.Search(query, this.elasticSearch.path, false);
        if (!full) {
            elasticObserval = elasticObserval.map((result: ElasticResult) => {

                return _.map(result.items, item => {
                    return {
                        '$key': item.$id,
                        'recipeId': item.recipeId,
                        'userId': item.userId
                    }
                });
            });
        }
        else {
            elasticObserval = elasticObserval.map((result: ElasticResult) => {
                result.items = _.forEach(result.items, (item: any) => {
                    item.$key = item.$id;
                });
                return result.items;
            });
        }
        return elasticObserval;
    }


}


// WEBPACK FOOTER //
// ./src/modules/recipes/providers/user-recipe-box-data.ts